import actions from '../../actionTypes';

export default (siteId, page, size, searchText, sorting, filters, areaId) => {
  return {
    type: actions.GET_TAGS,
    siteId,
    areaId,
    page,
    size,
    searchText,
    sorting,
    filters
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/getTags.js